import _regenerator from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.object.to-string.js";
import toPreviewData from "@/views/correspondence/task/components/util/preview-data";
import Editor from "@/components/editor";
export default {
  name: "pre-doc",
  components: {
    Editor: Editor
  },
  props: {
    content: {
      default: function _default() {
        return '';
      }
    },
    confirmId: {
      default: function _default() {
        return undefined;
      }
    },
    taskId: {
      default: function _default() {
        return undefined;
      }
    },
    sysParams: {
      default: function _default() {
        return {};
      }
    },
    paramsList: {
      default: function _default() {
        return [];
      }
    },
    preData: {
      default: function _default() {
        return '';
      }
    }
  },
  data: function data() {
    return {
      loading: false,
      previewData: '',
      data: this.preData
    };
  },
  methods: {
    toPreViewData: function toPreViewData() {
      if (this.content) {
        this.previewData = toPreviewData(this.content, this.list, this.sysParams);
        // this.$emit('data',this.previewData)
      }
    },
    getParamList: function getParamList() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _this.toPreViewData();
              return _context.a(2, Promise.resolve(_this.previewData));
          }
        }, _callee);
      }))();
    },
    getHtml: function getHtml() {
      console.log(this.$refs.editor.getData());
    }
  },
  created: function created() {
    // this.getHtml()
    // this.getParamList();
  }
};